import { Autocomplete } from '@Wonder-Cave/ui';
import { IDropdownValue } from '../Dropdown';

interface ICampaignTypeDropdownProps {
  value: any;
  options: IDropdownValue[];
  onChange: (newValue: IDropdownValue | undefined) => void;
  onBlur?: { (e: any): void; <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void; };
  disabled?: boolean;
  touched?: boolean;
  errorMessage?: string;
  placeholder?: string;
  loading?: boolean;
}

const NewCampaignTypeDropdown = ({
  value,
  errorMessage,
  disabled,
  loading,
  touched,
  onChange,
  onBlur,
  placeholder,
  options,
}: ICampaignTypeDropdownProps): JSX.Element => {
  return (
    <Autocomplete
      label="Campaign Type"
      loading={loading}
      value={options.find((ct) => ct.value === value) ?? { label: '', value: '' }}
      onChange={onChange}
      onBlur={onBlur}
      options={options}
      disabled={disabled || options.length === 0}
      placeholder={placeholder || "Select a Campaign Type"}
      error={options.length === 0 && !loading ? 'Client has no number for Provider' : errorMessage}
      showError={touched}
    />
  );
};

export default NewCampaignTypeDropdown;
